import { transformPaginationDto } from '@marketplace-web/domain/pagination-data'

import { FeedbackDto, FeedbackListModel, FeedbackModel } from '../types/feedback'
import { FeedbackListResp } from '../types/user-feedback'
import { transformUser } from './feedback-user'
import { transformComment } from './feedback-comment'

export const transformFeedback = ({
  id,
  user,
  feedback,
  user_id,
  feedback_user_id,
  rating,
  created_at_ts,
  system_feedback,
  comment,
  is_system_comment,
  can_comment,
  can_change,
  can_delete,
  can_change_comment,
  can_delete_comment,
  can_moderate,
  localization,
}: FeedbackDto): FeedbackModel => ({
  id,
  text: feedback,
  userId: user_id,
  feedbackUserId: feedback_user_id,
  rating,
  user: transformUser(user),
  comment: transformComment(comment, !!is_system_comment),
  createdAt: created_at_ts,
  isSystem: system_feedback,
  canReply: can_comment,
  canChange: can_change,
  canDelete: can_delete,
  canChangeComment: can_change_comment,
  canDeleteComment: can_delete_comment,
  canModerate: !!can_moderate,
  localization,
})

export const transformFeedbackResponse = ({
  pagination,
  user_feedbacks,
}: FeedbackListResp): FeedbackListModel => ({
  pagination: transformPaginationDto(pagination),
  feedback: user_feedbacks.map(transformFeedback),
})
